import "slick-carousel/slick/slick.css?__remix_sideEffect__";
import "slick-carousel/slick/slick-theme.css?__remix_sideEffect__";
import CaretLeft from "@sumerkit/icons/caret-left/ssr";
import CaretRight from "@sumerkit/icons/caret-right/ssr";
import { FC } from "react";
import Slider, { CustomArrowProps, Settings } from "react-slick";
import styles from "./carousel.module.css";
import { carouselProps } from "./carousel.types";

const Carousel: FC<carouselProps> = ({ children, className, ..._settings }) => {
  const PrevArrow: FC<CustomArrowProps> = ({ className, onClick }) => {
    return (
      <button className={`${styles.arrow} ${className}`} onClick={onClick}>
        <CaretLeft />
      </button>);

  };

  const NextArrow: FC<CustomArrowProps> = ({ className, onClick }) => {
    return (
      <button className={`${styles.arrow} ${className}`} onClick={onClick}>
        <CaretRight />
      </button>);

  };

  const settings: Settings = {
    arrows: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    ..._settings
  };

  return (
    <Slider {...settings} className={`${styles.slider} ${className || ""}`}>
      {children}
    </Slider>);

};

export default Carousel;